var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(-1603 -7423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 50,
    height: 40,
    transform: "translate(1603 7423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock-2",
    "data-name": "clock",
    d: "M-1140.5-5982a12.42,12.42,0,0,1-8.839-3.661A12.418,12.418,0,0,1-1153-5994.5a12.418,12.418,0,0,1,3.661-8.839A12.42,12.42,0,0,1-1140.5-6007a12.418,12.418,0,0,1,8.838,3.661A12.419,12.419,0,0,1-1128-5994.5a12.418,12.418,0,0,1-3.661,8.838A12.418,12.418,0,0,1-1140.5-5982Zm0-21.632a1,1,0,0,0-1,1v9a1,1,0,0,0,.4.8.983.983,0,0,0,.273.285l4.915,3.443a.991.991,0,0,0,.573.18,1.006,1.006,0,0,0,.82-.425,1,1,0,0,0-.246-1.393l-4.738-3.316v-8.575A1,1,0,0,0-1140.5-6003.632Z",
    transform: "translate(2769 13438)",
    fill: "#e54529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.93c10885ce6fc6d895c8255f52d881c2.svg";
export { ForwardRef as ReactComponent };